export default __webpack_public_path__ + "static/media/slider4.f21d8545.gif";